export default __webpack_public_path__ + "e334b2f330a62ea631515754d16c6e1d.png";